/* WarningRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const CheckboxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;

class WarningRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("rootsite-warning-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._wrapper = document.createElement("div");
        this._wrapper.classList.add("wrapper");

        this._titlePanel = document.createElement("h2");
        this._titlePanel.classList.add("summary-title");
        this._titlePanel.innerHTML = "Multi-Edit Sites";

        this._messageContainer = document.createElement("div");
        this._messageContainer.classList.add("message-continer");

        this._buttonBar = document.createElement("div");
        this._buttonBar.classList.add("summary-buttons");
        this._okButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
            type: "additive",
        });
        this._checkboxCtrl = new CheckboxControl({
            label: "Don't show this again.",
            darkTheme: true,
            labelShown: true,
        });

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._okButton.on("UserClick", (this._onOkClick = this._onOkClick.bind(this)));
    }
    _unregisterListeners() {
        this._okButton.removeAllListeners("UserClick");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /* jshint ignore:start */
    async shutdown() {
        this._unregisterListeners();
        await this._okButton.shutdown();
        await this._checkboxCtrl.shutdown();
        this._summaryPanel = undefined;
        this._errorPanel = undefined;
    }
    /* jshint ignore:end */

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._wrapper);
                this._messageContainer.innerHTML =
                    "<div class='msg'>The root site can’t be edited so it won't be changed.</div>";
                this._messageContainer.appendChild(this._checkboxCtrl.renderer.rootElement);
                this._wrapper.appendChild(this._titlePanel);
                this._wrapper.appendChild(this._messageContainer);
                this._wrapper.appendChild(this._buttonBar);
                // this._buttonBar.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonBar.appendChild(this._okButton.renderer.rootElement);
                // this._displaySummary();
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onOkClick() {
        this._model.resolve(this._checkboxCtrl.getValue());
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = WarningRenderer;
